import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MobileDialogData } from '../../common';
import { HeaderComponent } from '../header.component';

@Component({
    selector: 'nphs-user-select-mobile-dialog',
    templateUrl: './select-mobile-dialog.component.html',
    styleUrls: ['./select-mobile-dialog.component.scss'],
    standalone: false
})


export class SelectMobileDialogComponent implements OnInit {

  selectedMobile: any;
  mobileForm= new UntypedFormGroup({
  account:new UntypedFormControl(''),
  mobiles:new UntypedFormControl('',[Validators.required])
  })
  get mobiles(){
    return this.mobileForm.get('mobiles')
  }

  constructor(
    public dialogRef: MatDialogRef<HeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MobileDialogData
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {

  }

  onSubmit(){
    if (!this.mobileForm.valid) {
      return false;
    } else {
      this.dialogRef.close(this.selectedMobile);

    }
  }

}
